module.exports = __webpack_public_path__ + "img/P08.56628938.jpg";